import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Label, Input } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router";
import Drawer from "react-modern-drawer";
import { CiCircleRemove } from "react-icons/ci";
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";

// API-Service
import {
  getProductList,
  getProductListWithFilter,
} from "../../service/catalogue.service";
import { getCategoriesListingArray } from "../../service/dashboard.service";
import {
  getBrandsListing,
} from "../../service/dashboard.service";

// Redux-Settings
import {
  selectIsSmallScreen,
  selectBannerList,
} from "../../redux/utilitySlice";

import {
  setProductList,
  setFilteredList,
  setTotalItem,
  selectPageCount,
  selectTotalItem,
} from "../../redux/productSlice";

// Component
import MultiRangeSlider from "../../components/micro/multiRangeSlider/multiRangeSlider";
import CataloguePagination from "../../components/catalogue/CataloguePagination";
import ScrollToTop from "../../utils/ScrollToTop";
// Higher-Order-Component
import withLayout from "../../components/higherOrderComponent/PagesLayout/PagesLayout";

// Styles
import "react-loading-skeleton/dist/skeleton.css";
import "../../assets/scss/base/pages/homepage/CataloguePage.scss";
import { getBannersList } from "../../service/dashboard.service";

const imageCDN = process.env.REACT_APP_PINEAPPLE_IMAGE_CDN;


const PromoPage = () => {

  const dispatch = useDispatch();
  const pages = useSelector(selectPageCount);
  const { name } = useParams();
  const { state } = useLocation();
  const [categories, setCategories] = useState([])
  // const { state } = useSelector(selectCategoryDropdownValue);
  const totalItem = useSelector(selectTotalItem);
  const isSmallScreen = useSelector(selectIsSmallScreen);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState({});
  const [selectedBrand, setSelectedBrand] = useState({});
  const [barndsSelection, setBarndsSelection] = useState([]);
  const [subCategoriesSlection, setSubCategoriesSlection] = useState([]);
  const [optionSelection, setOptionSelection] = useState("");
  const [banner, setBanner] = useState("");
  const [loading, setLoading] = useState(false);

  const promoFlags = {
    isNewArrival: name === "new-arrival",
    isTrending: name === "trending",
    isBestSelling: name === "best-selling",
    isSuperSaver: name === "super-saver"
  };

  const promoFlag = Object.keys(promoFlags).find(key => promoFlags[key]) || "";

  var maxPriceValue = 1000;
  var minPriceValue = 0;
  const handleMinMax = ({ min, max }) => {
    maxPriceValue = max;
    minPriceValue = min;
  };

  const toggleDrawer = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const fetchCategoriesList = async () => {
    const response = await getCategoriesListingArray({
      order: 1,
      filter: "Active",
      getAll: "true",
      promoFlag
    });

    setCategories(response?.data?.data?.list);
  };

  useEffect(() => {
    fetchCategoriesList()
  }, [name])


  const fetchBarndList = async () => {
    const response = await getBrandsListing({
      filter: "Active",
      type: "",
      getAll: "true",
      isOnDashboard: "true",
      promoFlag
    });

    if (response?.data?.success) {
      const list = response?.data?.data?.list || [];

      // "All" option
      const allOption = {
        checked: true,
        Brand: {
          id: "barndAll",
          name: "All",
        },
      };

      // Actual brand list
      const brandList = list.map((item) => ({
        checked: false,
        Brand: {
          id: item?.id,
          name: item?.name,
          slug: item?.slug
        },
      }));

      // Prepend "All" at first position
      setBarndsSelection([allOption, ...brandList]);
    }

    return response;
  };


  useEffect(() => {
    setSelectedBrand({});
    setBarndsSelection([]);
    fetchBarndList();
  }, [name]);


  useEffect(() => {

    if (!categories?.length) return;

    // 1 Collect all subcategories from all categories
    const allSubCategories =
      categories.flatMap((cat) =>
        cat.SubCategory?.map((sub) => ({
          ...sub,
          checked: false,
        })) || []
      );

    // 2️ Add "All" on top (checked by default)
    const allOption = {
      id: "subCategoryAll",
      name: "All",
      checked: true,
    };

    // 3️ Update state
    setSubCategoriesSlection([allOption, ...allSubCategories]);

  }, [categories]);


  const handleCategoryCheckboxChange = (event) => {
    const { name: subCategoryIdLocal, checked } = event.target;

    const updatedCheckboxes = subCategoriesSlection?.map((subCategorieItem) =>
      subCategorieItem.id === subCategoryIdLocal
        ? { ...subCategorieItem, checked }
        : { ...subCategorieItem, checked: false }
    );

    setSubCategoriesSlection(updatedCheckboxes);

    //  Set Selected SubCategory
    const selected = updatedCheckboxes.find((item) => item.checked);
    setSelectedSubCategory(selected?.id === "subCategoryAll" ? "" : selected);
  };


  const handleBrandCheckboxChange = (event) => {
    const { name: brandIdLocal, checked } = event.target;

    const updatedCheckboxes = barndsSelection.map((brandItem) =>
      brandItem?.Brand?.id === brandIdLocal
        ? { ...brandItem, checked }
        : { ...brandItem, checked: false }
    );

    setBarndsSelection(updatedCheckboxes);

    //  Set selected brand
    const selected = updatedCheckboxes.find((item) => item.checked);
    setSelectedBrand(selected?.Brand?.id === "barndAll" ? "" : selected);
  };


  // Fetch products
  const handleFetchListing = async () => {
    setLoading(true);


    const response = await getProductList({
      categoryId: state?.id || "",
      brandId: selectedBrand?.Brand?.slug || "",
      subCategoryName: selectedSubCategory?.slug || "",
      subCategoryId: state?.subCatId || "",
      subCategoryTypeId: state?.subCategoryTypeId || "",
      isOnFlashSale: state?.isOnFlashSale || "",
      search: "",
      // ...(state?.promoFilter && { [state?.promoFilter]: true }),
      ...(name === "new-arrival" && { isNewArrival: name === "new-arrival" && true }),
      ...(name === "trending" && { isTrending: name === "trending" && true }),
      ...(name === "best-selling" && { isBestSelling: name === "best-selling" && true }),
      ...(name === "super-saver" && { isSuperSaver: name === "super-saver" && true }),
      page: pages > 0 ? pages : "",
      sort: optionSelection
    });
    if (response?.data?.success) {
      dispatch(setProductList(response?.data?.data?.list));
      dispatch(setFilteredList(response?.data?.data?.list));
      dispatch(setTotalItem(response?.data?.data?.count));
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchListing();
  }, [name, selectedSubCategory, optionSelection, selectedBrand]);

  // const handleFetchProductBasedOnFilterListing = async (page) => {
  //   setLoading(true);
  //   const response = await getProductList({

  //     // ...(state?.promoFilter && { [state?.promoFilter]: true }),
  //     ...(name === "new-arrival" && { isNewArrival: name === "new-arrival" && true }),
  //     ...(name === "trending" && { isTrending: name === "trending" && true }),
  //     ...(name === "best-selling" && { isBestSelling: name === "best-selling" && true }),
  //     ...(name === "super-saver" && { isSuperSaver: name === "super-saver" && true }),
  //     page: page,
  //     sort: optionSelection,
  //   });

  //   if (response?.data?.success) {
  //     dispatch(setProductList(response?.data?.data?.list));
  //     dispatch(setFilteredList(response?.data?.data?.list));
  //     dispatch(setTotalItem(response?.data?.data?.count));
  //     setLoading(false);
  //   }
  // };

  // Fetch products
  const handleFetchProductBasedOnFilterListing = async (number) => {

    const selectedSubCategoryIds = subCategoriesSlection
      ?.filter(item => item.checked)
      .map(item => item.id)

    const isSubCategoryAllSelected =
      selectedSubCategoryIds?.includes("subCategoryAll")

    const selectedBrandIds = barndsSelection
      ?.filter(item => item.checked)
      .map(item => item.id)

    const response = await getProductListWithFilter({

      // ✅ Only send categoryIds if NOT "All"
      ...(!isSubCategoryAllSelected && selectedSubCategoryIds?.length && {
        categoryIds: selectedSubCategoryIds,
      }),

      // ✅ Brand filter (same logic can be applied if needed)
      ...(selectedBrandIds?.length && {
        brandIds: selectedBrandIds,
      }),

      maxPrice: maxPriceValue,
      minPrice: minPriceValue,
      sort: optionSelection || "",
      ...(name === "new-arrival" && { isNewArrival: name === "new-arrival" && true }),
      ...(name === "trending" && { isTrending: name === "trending" && true }),
      ...(name === "best-selling" && { isBestSelling: name === "best-selling" && true }),
      ...(name === "super-saver" && { isSuperSaver: name === "super-saver" && true }),
    });
    if (response?.data?.success) {
      dispatch(setProductList(response?.data?.data?.list));
      dispatch(setFilteredList(response?.data?.data?.list));
      dispatch(setTotalItem(response?.data?.data?.list?.length));
      toggleDrawer();
    }
  };

  // const handleFetchProductBasedOnFilterListing = async (page) => {
  //   const response = await getProductList({
  //     // categoryId: categoryName || "",
  //     // ...(brandName && {
  //     //   brandId: brandName,
  //     // }),
  //     // ...(subCategoryName && {
  //     //   subCategoryName: subCategoryName,
  //     // }),
  //       ...(name ==="new-arrival" && { isNewArrival:name ==="new-arrival" && true}),
  //    ...(name ==="trending" && { isTrending:name ==="trending" && true}),
  //    ...(name ==="best-selling" && { isBestSelling:name ==="best-selling" && true}),
  //     ...(name ==="super-saver" && {isSuperSaver:name ==="super-saver" && true}),
  //     page: page,
  //     maxPrice: maxPriceValue,
  //     minPrice: minPriceValue,
  //   });

  //   if (response?.data?.success) {
  //     dispatch(setProductList([]));
  //     dispatch(setFilteredList([]));
  //     dispatch(setProductList(response?.data?.data?.list));
  //     dispatch(setFilteredList(response?.data?.data?.list));
  //     dispatch(setTotalItem(response?.data?.data?.count));
  //     toggleDrawer();
  //   }
  // };

  const resetSubCategories = () => {
    if (!categories?.length) return;

    const allSubCategories =
      categories.flatMap(cat =>
        cat.SubCategory?.map(sub => ({
          ...sub,
          checked: false,
        })) || []
      );

    setSubCategoriesSlection([
      {
        id: "subCategoryAll",
        name: "All",
        checked: true,
      },
      ...allSubCategories,
    ]);

    setSelectedSubCategory({});
  };

  const resetBrands = () => {
    setBarndsSelection(prev =>
      prev.map(item => ({
        ...item,
        checked: item?.Brand?.id === "barndAll",
      }))
    );

    setSelectedBrand({});
  };


  useEffect(() => {
    resetSubCategories();
    resetBrands();
    setOptionSelection("");
    setSelectedSubCategory({});
    setSelectedBrand({});
  }, [name]); 


  const handleClearFilter = async () => {
    // Reset UI state
    resetSubCategories();
    resetBrands();

    // Reset price
    maxPriceValue = 10000;
    minPriceValue = 0;

    // Reset sort
    setOptionSelection("");

    // Fetch unfiltered listing
    await handleFetchListing();

    // Close drawer on mobile
    toggleDrawer();
  };


  useEffect(() => {
    const fetchBanner = async () => {
      let BannerType;
      if (name == "new-arrival") {
        BannerType = "isNewArrival";
      } else if (name == "trending") {
        BannerType = "isTrending";
      } else if (name == "best-selling") {
        BannerType = "isBestSelling";
      } else {
        BannerType = "isSuperSaver";
      }
      try {
        const response = await getBannersList({
          filter: "Active",
          type: BannerType,
        });
        if (response?.data?.success) {
          setBanner(response?.data?.data?.list);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchBanner();
  }, [name]);

  function capitilize(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{capitilize(name?.replaceAll(/-/g, " "))}</title>
      </Helmet>
      <ScrollToTop />
      <div className="catalogue__page__block">
        <div className="brands__info__block promo__page__info__block">
          <span
            className="brands__info__block--name"
            style={{ marginRight: "0.2rem", textTransform: "capitalize" }}
          >
            {name?.replaceAll(/-/g, " ")}{" "}
          </span>
          <span className="brands__info__block--itemsCount">
            {" "}
            - {totalItem} Items
          </span>
        </div>
        <div className="promo__banner__block">
          <img src={`${imageCDN}/${banner[0]?.file}`} alt="" />
        </div>
        <div className="catalogue__page__category">
          {isSmallScreen ? (
            <div>
              <button className="filter__toggle__btn" onClick={toggleDrawer}>
                Filter
              </button>
              <Drawer
                open={isSidebarOpen}
                onClose={toggleDrawer}
                direction="left"
                lockBackgroundScroll={true}
                className="productFilter__drawer__block__navbar"
              >
                <CiCircleRemove
                  onClick={toggleDrawer}
                  className="bannerType-menu-icon"
                />
                <div className="catalogue__page__sidebar">
                  <div className="catalogue__page__filter__category">
                    <h3>Sub Categories</h3>
                    {/* <div className="catalogue__page__filter__category__item">
                      <Input
                        type="checkbox"
                        name="All"
                        checked={true}
                        onChange={handleCategoryCheckboxChange}
                      />{" "}
                      <Label check>All</Label>
                    </div> */}
                    {subCategoriesSlection?.map((subCategoriesSlectionItem) => (
                      <div
                        key={subCategoriesSlectionItem?.id}
                        className="catalogue__page__filter__category__item"
                      >
                        <Input
                          type="checkbox"
                          name={subCategoriesSlectionItem?.id}
                          checked={subCategoriesSlectionItem?.checked}
                          onChange={handleCategoryCheckboxChange}
                        />{" "}
                        <Label check>{subCategoriesSlectionItem?.name}</Label>
                      </div>
                    ))}
                  </div>
                  {barndsSelection?.length > 0 && <div className="catalogue__page__filter__category catalogue__page__filter__category--v2">
                    <h3>Brands</h3>
                    {barndsSelection.map(barndsSlectionItem =>
                      <div key={barndsSlectionItem?.id} className="catalogue__page__filter__category__item">
                        <Input
                          type="checkbox"
                          name={barndsSlectionItem?.Brand?.id}
                          checked={barndsSlectionItem.checked}
                          onChange={handleBrandCheckboxChange}
                        />
                        {' '}
                        <Label check>
                          {barndsSlectionItem?.Brand?.name}
                        </Label>
                      </div>
                    )}
                  </div>}
                  <div className="catalogue__page__filter__category catalogue__page__filter__category--v2">
                    <h3>Price</h3>
                    <MultiRangeSlider
                      min={0}
                      max={10000}
                      onChange={({ min, max }) => {
                        handleMinMax({ min, max });
                      }}
                    />
                  </div>
                  <div className="filter__btn__block">
                    <button
                      onClick={handleFetchProductBasedOnFilterListing}
                      className="filter__btn"
                    >
                      Apply Filter
                    </button>
                    <button
                      onClick={handleClearFilter}
                      className="clear_all__btn"
                    >
                      Clear all
                    </button>
                  </div>
                </div>
              </Drawer>
            </div>
          ) : (
            <h3>Filters</h3>
          )}
          <div className="sorting__filter__block">
            <Label for="exampleSelect">Sort By :</Label>
            <Input
              id="exampleSelect"
              name="select"
              type="select"
              onChange={(e) => setOptionSelection(e?.target?.value)}
            >
              <option value="latest">Latest</option>
              <option value="PriceAsc">Price Ascending</option>
              <option value="PriceDesc">Price Descending</option>
            </Input>
          </div>
        </div>
        <div className="catalogue__page__main__block">
          <div
            className={`${!isSmallScreen
              ? "catalogue__page__sidebar"
              : "catalogue__page__sidebar display__none"
              } `}
          >
            <div className="catalogue__page__filter__category">
              <h3>Sub Categories</h3>
              {subCategoriesSlection?.map((subCategoriesSlectionItem) => (
                <div
                  key={subCategoriesSlectionItem?.id}
                  className="catalogue__page__filter__category__item"
                >
                  <Input
                    type="checkbox"
                    name={subCategoriesSlectionItem.id}
                    checked={subCategoriesSlectionItem.checked}
                    onChange={handleCategoryCheckboxChange}
                  />{" "}
                  <Label check>{subCategoriesSlectionItem?.name}</Label>
                </div>
              ))}
            </div>
            {/* <div className="catalogue__page__filter__category catalogue__page__filter__category--v2">
                    <h3>Brands</h3>
                    {barndsSelection.map(barndsSlectionItem => 
                        <div key={barndsSlectionItem?.id} className="catalogue__page__filter__category__item">
                            <Input
                                type="checkbox"
                                name={barndsSlectionItem.id}
                                checked={barndsSlectionItem.checked}
                                onChange={handleBrandCheckboxChange}
                            />
                            {' '}
                            <Label check>
                                {barndsSlectionItem?.name}
                            </Label>
                        </div>
                    )}
                </div> */}
            {barndsSelection?.length > 0 && (
              <div className="catalogue__page__filter__category catalogue__page__filter__category--v2">
                <h3>Brands</h3>
                {barndsSelection.map((barndsSlectionItem) => (

                  <div
                    key={barndsSlectionItem?.id}
                    className="catalogue__page__filter__category__item"
                  >
                    <Input
                      type="checkbox"
                      name={barndsSlectionItem?.Brand?.id}
                      checked={barndsSlectionItem.checked}
                      onChange={handleBrandCheckboxChange}
                    />{" "}
                    <Label check>{barndsSlectionItem?.Brand?.name}</Label>
                  </div>
                ))}
              </div>
            )}
            <div className="catalogue__page__filter__category catalogue__page__filter__category--v2">
              <h3>Price</h3>
              <MultiRangeSlider
                min={0}
                max={10000}
                onChange={({ min, max }) => {
                  handleMinMax({ min, max });
                }}
              />
            </div>
            <div className="filter__btn__block">
              <button
                onClick={handleFetchProductBasedOnFilterListing}
                className="filter__btn"
              >
                Apply Filter
              </button>
              <button onClick={handleClearFilter} className="clear_all__btn">
                Clear all
              </button>
            </div>
          </div>
          <div className="catalogue__page__products__block">
            <div className="catalogue__page__products__block__wrapper">
              {loading ? (
                <div className="catalogueProductsContainerMain">
                  {[1, 2, 3, 4, 5, 6, 7, 8]?.map((placeHolderItem) => (
                    <div
                      key={placeHolderItem}
                      className="catalouge__product__item"
                    >
                      <Skeleton height={150} />
                      <Skeleton height={25} />
                      <Skeleton count={3} />
                    </div>
                  ))}
                </div>
              ) : (
                <CataloguePagination setLoading={setLoading} handleFetchProductBasedOnFilterListing={handleFetchProductBasedOnFilterListing} />
              )}
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default withLayout(PromoPage, { isProductPage: true });
